import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M22.4198 7H9.58033C8.07919 7.0237 6.64874 7.64181 5.60272 8.71876C4.5567 9.79571 3.98052 11.2436 4.00057 12.7448V16.0521C3.98052 17.5533 4.5567 19.0012 5.60272 20.0781C6.64874 21.1551 8.07919 21.7732 9.58033 21.7969H10.7503V25L16.9525 21.7969H22.4198C23.9209 21.7732 25.3514 21.1551 26.3974 20.0781C27.4434 19.0012 28.0196 17.5533 27.9996 16.0521V12.7448C28.0196 11.2436 27.4434 9.79571 26.3974 8.71876C25.3514 7.64181 23.9209 7.0237 22.4198 7ZM10.0003 15.9996C9.70365 15.9996 9.41366 15.9116 9.16699 15.7468C8.92033 15.582 8.72808 15.3478 8.61455 15.0737C8.50103 14.7996 8.47132 14.498 8.5292 14.2071C8.58707 13.9161 8.72993 13.6488 8.9397 13.4391C9.14947 13.2293 9.41673 13.0864 9.70769 13.0286C9.99865 12.9707 10.3002 13.0004 10.5743 13.1139C10.8484 13.2274 11.0827 13.4197 11.2475 13.6664C11.4123 13.913 11.5003 14.203 11.5003 14.4997C11.5003 14.8975 11.3422 15.279 11.0609 15.5603C10.7796 15.8416 10.3981 15.9996 10.0003 15.9996ZM16.0001 15.9996C15.7051 15.9922 15.4189 15.898 15.1772 15.7288C14.9355 15.5596 14.7491 15.3228 14.6413 15.0482C14.5335 14.7735 14.5091 14.4732 14.5712 14.1847C14.6332 13.8963 14.7789 13.6326 14.9901 13.4265C15.2013 13.2205 15.4686 13.0813 15.7585 13.0264C16.0483 12.9715 16.348 13.0033 16.6199 13.1179C16.8918 13.2324 17.1239 13.4246 17.2871 13.6704C17.4503 13.9162 17.5374 14.2046 17.5375 14.4997C17.5376 14.6999 17.4976 14.898 17.4198 15.0825C17.3421 15.2669 17.2283 15.434 17.085 15.5738C16.9417 15.7136 16.7719 15.8233 16.5856 15.8964C16.3993 15.9695 16.2002 16.0046 16.0001 15.9996ZM21.9998 15.9996C21.7031 15.9996 21.4132 15.9116 21.1665 15.7468C20.9198 15.582 20.7276 15.3478 20.614 15.0737C20.5005 14.7996 20.4708 14.498 20.5287 14.2071C20.5866 13.9161 20.7294 13.6488 20.9392 13.4391C21.149 13.2293 21.4162 13.0864 21.7072 13.0286C21.9981 12.9707 22.2997 13.0004 22.5738 13.1139C22.8479 13.2274 23.0821 13.4197 23.247 13.6664C23.4118 13.913 23.4997 14.203 23.4997 14.4997C23.4997 14.8975 23.3417 15.279 23.0604 15.5603C22.7791 15.8416 22.3976 15.9996 21.9998 15.9996Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
